import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2, SecurityContext,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatatablesQueriesService } from '@formbird/services';
import { ComponentDefinition, SearchOptions, SharedConstants } from '@formbird/types';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ChangedDocumentService, ClientConstants } from 'formbird-services';
import * as _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { CellTemplateServices } from '../../../../formbird-sc-shared/src/lib/cell-template.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { sclHandlebars } from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import { SclDatatableResizeService } from '../../../../formbird-sc-shared/src/lib/scl-datatable-resize.service';
import { SclDatatableResponsiveService } from '../../../../formbird-sc-shared/src/lib/scl-datatable-responsive.service';
import { SclExportService } from '../../../../formbird-sc-shared/src/lib/scl-export.service';
import { SclUtilDocumentService } from '../../../../formbird-sc-shared/src/lib/scl-util-document.service';
import { SclUtilFilterService } from '../../../../formbird-sc-shared/src/lib/scl-util-filter.service';
import { SclUtilUrlService } from '../../../../formbird-sc-shared/src/lib/scl-util-url.service';
import { UtilSharingNgService } from '../../../../formbird-sc-shared/src/lib/util-sharing-ng.service';
import { ConfigService } from '../../../../formbird-services/src/lib/services/config/config.service';
import { DataService } from '../../../../formbird-services/src/lib/services/data/data.service';
import { NotificationService } from '../../../../formbird-services/src/lib/services/notification/notification.service';
import { ClientRulesService } from '../../../../formbird-services/src/lib/services/rules/client-rules.service';
import { SearchService } from '../../../../formbird-services/src/lib/services/search/search.service';
import * as numeral from './../../assets/numerals/numeral.min.js';
import { DataTableEvents } from './datatables.events';
import { DataTableImport } from './datatables.import';
import { DataTableSearch } from './datatables.search';
import { DeviceDetectService } from 'formbird-sc-shared';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { DataTablesExportFiles } from './datatables.export.files';

pdfMake.addVirtualFileSystem(pdfFonts);

// elasticsearch index.max_result_window
const MAX_EXPORT_RESULT = 10000;

declare var $;
declare var componentHandler: any;
const logger = console;
const routerService = (window as any).FormbirdServiceInjector.get('RouterService');
const CONFIRM_FROM_DIALOG_CANCEL = 'CONFIRM_FROM_DIALOG_CANCEL';
const CONFIRM_FROM_DIALOG_DISCARD = 'CONFIRM_FROM_DIALOG_DISCARD';
const CONFIRM_FROM_DIALOG_SAVE = 'CONFIRM_FROM_DIALOG_SAVE';

interface DatatablesComponentDefinition extends ComponentDefinition {
  closeOverlayOnSave?: boolean;
  dataSource?: string;
  dataSourceName?: string;
  handlebarsHelpers?: any;
  searchOptions?: any;
  responsive?: boolean;
  showHeadings?: boolean;
  forcePageInfo?: any;
  showSelected?: boolean;
  showSearch?: boolean;
  noChildDocLink?: boolean;
  showReload?: boolean;
  pageSelect?: any;
  allSelect?: any;
  enableColumnResizing?: boolean;
  enableColumnMoving?: boolean;
  enableRowGroup?: boolean;
  multiSelect?: boolean;
  columnSearch?: boolean;
  delayBeforeCallNum?: number;
  rowsPerPage?: number;
  lengthMenu?: any[];
  selectOnLoad?: boolean;
  disableAutoDisplay?: boolean;
  refreshInterval?: number;
  backgroundRefresh?: boolean;
  enforceWidth?: boolean;
  hideNoData?: boolean;
  templateTarget?: string;
  template?: [any?];
  hideChildDocSelection?: boolean;
  childLabel?: string;
  gridColumns?: [any?];
  hiddenColumns?: [any?];
  simpleColumns?: [any?];
  filter?: string;
  linkFunction?: any;
  updateWatchFields?: any;
  exportTypes?: any;
  headerRotate?: any;
  headerHeight?: any;
  fontSize?: any;
  exportSettings?: any;
  queryName?: string;
  headerWrapping?: boolean;
  headerColor?: any;
  esTrackTotalHits?: boolean;
  searchBoxFilter?: string;
  searchBoxAnyCase?: boolean;
  noClearBeforeSelectAll?: boolean;
  selectionView?: boolean;
}

@Component({
  templateUrl: './datatables.component.html',
  styleUrls: ['./datatables.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatatablesComponent extends AbstractComponent<DatatablesComponentDefinition> implements OnInit, OnDestroy, AfterViewInit {

  SEARCH_LENGTH_LIMIT = 100;

  SELECT_ALL_LABEL = 'Select All';
  SELECT_ALL_FILTERED_LABEL = 'Select All Filtered';
  SELECTED_STATUS_LABEL = '{{{numRows}}} selected';

  @Input() account: any;
  @ViewChild('dataTable', {static: true}) table: any;
  @ViewChild('datatableWrapper') dtWrapper;
  @ViewChild('divChildTemplate') divChildTemplate;
  @ViewChild('selectRef') selectRef;
  dataTable: any;
  searchOptions: SearchOptions;
  dtExport: DataTablesExportFiles;
  dtEvents: DataTableEvents;
  dtSearch: DataTableSearch;
  dataSource: string;
  noChildDocLink: boolean;
  excludeResizeCol: any;
  excludeColumnSort: [any?];
  refreshIntervalTimer;
  isFirstLoad: boolean;
  wrapText: string;
  notHideLabel: boolean;
  hasChildDoc: boolean;
  hideNoData: boolean;
  lastSelectedIndex: number;
  deselected: boolean;
  columnSort: [any?];
  columnIndex: [number?];
  dtcolumns: [any?];
  dontWatch: boolean;
  hideHeadings: string;
  hideSearch: string;
  showSelected: boolean;
  showReload: boolean;
  device: string;
  selectedDocumentsRel: any;
  prevSelectedDocumentsRel: any;
  filteredTemplate: [any?];
  filteredTemplateArray: [any?];
  selectedTemplate: any;
  dtSource: any;
  dtData: any;
  initialResizeCol: any;
  changeTemplateToogle: boolean;
  selectedChildDocId: string;
  templateName: string;
  showChildDocTitle: boolean;
  parentDoc: any;
  defaultFields: any;
  childDocumentInfo: any;
  templateId: string;
  selectedChildTplId: string;
  changeTemplate: boolean;
  parentId: string;
  ngModelOptions: any;
  dtsrch: string;
  searchOffline: boolean;
  includeDeleted: boolean;
  refreshInterval: any;
  isReloadOnce: boolean;
  element: any;
  rowClass: [any?];
  rowGroup: any;
  exportQuery: any;
  queryName: string;
  headerWrapping: boolean;
  maxColumnWidth: number;
  isUpdated: boolean;
  delayBeforeCallNum: number;
  columnSearchList: object;


  didUndoRedo = false;
  selectAllBox = false;
  selectAllItems = '';
  selectAllLabel = this.SELECT_ALL_LABEL;
  selectedStatusLabel: string;
  selectedStatusDisplay = false;
  selectedDocumentSource = [];
  isSelectionView = false;
  isTemplate = false;


  showButtonsMobile = false;
  showExportButton = {
    csv: false,
    pdf: false
  };
  templateArray: any;
  childLabel: any;

  resizableCol: any;

  columnSearch: boolean;
  pageSelect: boolean;
  allSelect: boolean;
  forcePageInfo: boolean;
  screenView = 'dt-desktop';
  screenDevice = 'lg';
  datatableWrapperWidth: number;
  componentWidth: number;
  resizeTimeout: any;

  contextParams: any;
  loggedInUserService: any;
  lengthMenu: [any?];
  trackTotalHitsLabel = '';

  pagination = {
    init_page: 1,
    start_page: 1,
    current_page: 1,
    total_items: 0,
    page_items: [],
    rows_per_page: 10,
    last_page: 0,
    more_items: 0,
    extend: [],
    isDeep: false
  };

  private documentListService: any;
  private documentSaveService: any;
  private modalService: any;
  private modifiedFieldService: any;
  private unsavedDocumentService: any;

  private shouldSelectRow = true;
  private selectInfo: any;
  private lastSelectInfo: any;
  private fromEvent: any;
  private shouldUpdateTemplateName = true;
  private isSaving = false;
  private isDrawing = false;
  private isFromDocumentUpdate = false;
  private initCompleted = false;
  private prevChildScope = undefined;
  private prevUpdatedDoc = undefined;
  private lastUpdatedDoc = undefined;

  searchBoxAnyCase: boolean;
  searchClientService: any;
  isMobileDetect: boolean;
  browser: string;

  constructor(
    protected cd: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    private configService: ConfigService,
    private deviceDetectService: DeviceDetectService,
    private notificationService: NotificationService,
    private searchService: SearchService,
    private utilSharingNgService: UtilSharingNgService,
    private sclUtilFilterService: SclUtilFilterService,
    private sclDatatableResponsiveService: SclDatatableResponsiveService,
    private sclDatatableResizeService: SclDatatableResizeService,
    private sclUtilUrlService: SclUtilUrlService,
    private dataService: DataService,
    private clientRulesService: ClientRulesService,
    private sclUtilDocumentService: SclUtilDocumentService,
    private elem: ElementRef,
    private zone: NgZone,
    private datePipe: DatePipe,
    private renderer: Renderer2,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private httpClient: HttpClient,
    private datatablesQueriesService: DatatablesQueriesService,
    private sanitizer: DomSanitizer,
    private cellTemplateServices: CellTemplateServices
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cd);
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.documentListService = this.formbirdInjectorService.get('DocumentListService');
    this.documentSaveService = this.formbirdInjectorService.get('DocumentSaveService');
    this.modalService = this.formbirdInjectorService.get('ModalService');
    this.modifiedFieldService = this.formbirdInjectorService.get('ModifiedFieldService');
    this.unsavedDocumentService = this.formbirdInjectorService.get('UnsavedDocumentService');
    this.searchClientService = this.formbirdInjectorService.get('SearchClientService');
  }

  resizeObserver;
  sclExportService: SclExportService;

  ngOnInit() {

    this.contextParams = {
      document: this.document,
      doc: this.document,
      account: this.account, // the account document from scope
      tpl: this.template,
      template: this.template,
      tplItem: this.componentDefinition, // For BackCompatibility
      componentDefinition: this.componentDefinition // the current components configuration details
    };

    this.dtExport = new DataTablesExportFiles(this);
    this.dtEvents = new DataTableEvents();
    this.sclExportService = new SclExportService(this.httpClient);
    this.dtSearch = new DataTableSearch(this, this.configService, this.datatablesQueriesService, sclHandlebars);

    this.componentSetupService.setupStandardProperties(this);
    this.columnSearchList = {};

    this.componentDefinition.hiddenColumns = this.componentDefinition.hiddenColumns ?? [];

    this.componentDefinition.enableColumnMoving = (this.componentDefinition.enableColumnMoving === undefined) ? false :
      this.componentDefinition.enableColumnMoving;

    this.componentDefinition.enableColumnResizing = (this.componentDefinition.enableColumnResizing === undefined) ? false :
      this.componentDefinition.enableColumnResizing;

    this.componentDefinition.noClearBeforeSelectAll = (this.componentDefinition.noClearBeforeSelectAll === undefined) ? false :
      this.componentDefinition.noClearBeforeSelectAll;

    this.componentDefinition.selectionView = (this.componentDefinition.selectionView === undefined) ? false :
      this.componentDefinition.selectionView;

    // enable child doc functionality if template is defined
    // this.hasChildDoc = !this.componentDefinition.template;
    // this.hasChildDoc = (this.componentDefinition.template === undefined) ? false : true;
    this.hasChildDoc = this.componentDefinition.template !== undefined;

    const detect: boolean = this.deviceDetectService.detectMobile();
    const detectDevice : any = this.deviceDetectService.detectBrowser();
    this.device = detectDevice?.device;
    this.browser = detectDevice?.browser;
    if (detect) {
      this.isMobileDetect = true;
    }
  }

  ngAfterViewInit() {

    const importDatatable = new DataTableImport();
    importDatatable.isColReorder = this.componentDefinition.enableColumnMoving;
    importDatatable.isColResize = this.componentDefinition.enableColumnResizing;
    importDatatable.isRowGroup = this.componentDefinition.enableRowGroup;

    importDatatable.loadExtensions().then(() => {
      this.initDatatable();
      this.setupChangeDetection();
      this.watchDocument();

      const savingSub: Subscription = this.documentSaveService.onDocumentSaving().subscribe((isDocSaving: boolean) => {
        this.isSaving = isDocSaving;
      });
      this.subs.add(savingSub);

    }, (err) => {
      console.log('Error loading datatable extensions: ' + err.msg);
    });
  }

  updateComponentDefChange(componentDefinition) {

    // clone ComponentDefinition from store due to some property settings on it causes error of readonly/not extensible object
    this.componentDefinition = { ...componentDefinition };

    this.initChildTemplate();

    this.disabled = componentDefinition.enabled === false;

    if(this.table){
      for( const [i, col] of this.componentDefinition.gridColumns.entries()){
        const column = this.table.column(i);
        column.visible(!this.componentDefinition.hiddenColumns.includes(i));
        this.componentDefinition.gridColumns[i].visible = !this.componentDefinition.hiddenColumns.includes(i);
      }

      if(this.columnSearch){
        this.clearColumnSearch();
        this.generateColumnSearch();
      }

      this.dtEvents.initializeResize(this);
    }

    this.onClickReload();
  }

  onFieldValueChanged(fieldValue) {

    const newVal =  _.orderBy(_.map(fieldValue, 'documentId'), ['documentId']);
    const oldVal =  _.orderBy(_.map(this.fieldValue, 'documentId'), ['documentId']);

    if (_.isEqual(oldVal, newVal)) {
      this.didUndoRedo = false;
      return;
    }

    this.fieldValue = fieldValue;
    this.selectedDocumentsRel = fieldValue ? fieldValue : [];
    this.onClickReload();
    this.didUndoRedo = true;
    this.dtEvents.selectedStatus(this);

    this.detectChanges();
  }

  private initChildTemplate() {
    this.filteredTemplate = [];
    this.filteredTemplateArray = [];
    if (this.componentDefinition.template) {
      this.childLabel = (this.componentDefinition.childLabel === undefined) ? 'Add a new child document' :
        this.componentDefinition.childLabel;

      this.componentDefinition.template.forEach((val, i) => {
        const isVisible = (val.visible === undefined) ? true : val.visible;
        if (isVisible) {
          this.filteredTemplate.push(val);
        }
      });

      this.filteredTemplateArray = this.filteredTemplate;
    }
  }

  private async saveDocumentList(successFunc, errorFunc) {
    const _self = this;
    this.documentSaveService.saveDocumentLists([this.formParameters.unsavedDocumentListId]).then(
      function allPromiseSuccessFunc(result) {
        if (result.error) {
          _self.modalService.showDialog(result.error.message, 'ERROR');
          errorFunc();
        } else {
          successFunc(result);
        }
      },
      function promiseErrorFunc(err) {
        this.modalService.showDialog(err.message, 'ERROR');
        errorFunc();
      }
    );
  }

  initDatatable() {
    $.fn.dataTable.ext.errMode = 'none';

    this.initialResizeCol = [];
    this.searchOptions = {
      document: this.document,
      filter: {},
      includeDeleted: false,
      searchOfflineOnly: false
    };

    this.element = this.elem.nativeElement;

    // initial setting for sharedData PushedRowValue object=> used in sc-audit-table displayDiff code
    this.utilSharingNgService.fnPassedDataObject(this.fieldName, 'PushedRowValue', []);
    if (typeof this.componentDefinition.dataSource === 'undefined' || this.componentDefinition.dataSource === null) {
      this.dataSource = 'filter';
    } else {
      this.dataSource = this.componentDefinition.dataSource;
    }

    // Set up handlebars for this component
    sclHandlebars.initHandlebars(this.componentDefinition.handlebarsHelpers);

    this.searchBoxAnyCase = (this.componentDefinition.searchBoxAnyCase === undefined) ? false : this.componentDefinition.searchBoxAnyCase;

    this.searchOffline = (this.componentDefinition.searchOptions === undefined) ? false :
      (this.componentDefinition.searchOptions.searchOfflineOnly === undefined) ? false :
        this.componentDefinition.searchOptions.searchOfflineOnly;

    this.includeDeleted = (this.componentDefinition.searchOptions === undefined) ? false :
      (this.componentDefinition.searchOptions.includeDeleted === undefined) ? false :
        this.componentDefinition.searchOptions.includeDeleted;

    const responsive = (this.componentDefinition.responsive === undefined) ? true : this.componentDefinition.responsive;
    this.noChildDocLink = (this.componentDefinition.noChildDocLink === undefined) ? false : this.componentDefinition.noChildDocLink;
    this.showReload = (this.componentDefinition.showReload === undefined) ? false : this.componentDefinition.showReload;
    this.pageSelect = (this.componentDefinition.pageSelect === undefined) ? false : this.componentDefinition.pageSelect;
    this.allSelect = (this.componentDefinition.allSelect === undefined) ? false : this.componentDefinition.allSelect;

    this.rowGroup = false;
    let rowGroupField = '';

    this.resizableCol = (this.componentDefinition.enableColumnResizing === undefined) ? false :
      this.componentDefinition.enableColumnResizing;

    this.excludeResizeCol = [];
    this.excludeColumnSort = [];
    const initialResizeCol = [];

    const excludeMovableCol = [];

    this.componentDefinition.multiSelect = (this.componentDefinition.multiSelect === undefined) ? false :
      this.componentDefinition.multiSelect;
    this.columnSearch = (this.componentDefinition.columnSearch === undefined) ? false : this.componentDefinition.columnSearch;
    this.delayBeforeCallNum = (this.componentDefinition.delayBeforeCallNum === undefined) ? 200 :
      this.componentDefinition.delayBeforeCallNum;
    const disableSave = (this.componentDefinition.disableSave === undefined) ? false : this.componentDefinition.disableSave;
    this.componentDefinition.rowsPerPage = (this.componentDefinition.rowsPerPage === undefined) ? 10 :
      Number(this.componentDefinition.rowsPerPage);

    this.componentDefinition.lengthMenu = (this.componentDefinition.lengthMenu === undefined) ? [10, 25, 50, 100] :
      this.componentDefinition.lengthMenu;

    if (this.componentDefinition.lengthMenu !== undefined) {

      if(!this.componentDefinition.lengthMenu.includes(this.componentDefinition.rowsPerPage)) {
        this.componentDefinition.lengthMenu.push(this.componentDefinition.rowsPerPage);
        this.componentDefinition.lengthMenu.sort((a, b) => a - b);
      }

      // check if multiArray
      let lenKey = this.componentDefinition.lengthMenu;
      let lenLabel = this.componentDefinition.lengthMenu;
      if (typeof this.componentDefinition.lengthMenu[0] === 'object' ) {
        [lenKey, lenLabel] = this.componentDefinition.lengthMenu;
      }
      this.lengthMenu = [];
      for (const [i, len] of lenKey.entries()) {
        let value = len;
        if (this.isNumeric(len)) {
          // tslint:disable-next-line:radix
          value = parseInt(len);
        }
        this.lengthMenu.push({
          value,
          text: lenLabel[i]
        });
      }
    }

    const selectOnLoad = (this.componentDefinition.selectOnLoad === undefined) ? false : this.componentDefinition.selectOnLoad;

    // const exportTypes = (this.componentDefinition.exportTypes === undefined) ? [] : this.componentDefinition.exportTypes;
    // const defExportTypes = {copy: 'copyHtml5'};
    const exportTypes = (this.componentDefinition.exportTypes === undefined) ? [] : this.componentDefinition.exportTypes;
    const defExportTypes = ['csv', 'pdf'];
    for (const exportType of exportTypes) {
      const type = exportType.toString().toLowerCase();
      this.showExportButton[type] = exportType;
    }

    this.componentDefinition.disableAutoDisplay = (this.componentDefinition.disableAutoDisplay === undefined) ?
      false : this.componentDefinition.disableAutoDisplay;

    this.refreshInterval = (this.componentDefinition.refreshInterval === undefined) ? 0 :
      this.componentDefinition.refreshInterval;
    const backgroundRefresh = (this.componentDefinition.backgroundRefresh === undefined) ? false :
      this.componentDefinition.backgroundRefresh;
    this.refreshIntervalTimer = null;
    this.isFirstLoad = true;

    this.wrapText = (this.componentDefinition.enforceWidth === true ||
      this.componentDefinition.enforceWidth === undefined) ? 'wrapText' : '';

    this.hideNoData = (this.componentDefinition.hideNoData === undefined) ? false : this.componentDefinition.hideNoData;

    this.componentDefinition.templateTarget = (this.componentDefinition.templateTarget === undefined) ? 'currentWindow' :
      this.componentDefinition.templateTarget;

    this.notHideLabel = (this.componentDefinition.label === undefined) ? false : (this.componentDefinition.label.length !== 0);

    if (this.componentDefinition.queryName) {
      this.queryName = this.componentDefinition.queryName;
    }

    this.lastSelectedIndex = 0;
    this.deselected = true;
    this.columnSort = [];
    this.columnIndex = [];
    this.dontWatch = true;


    const setShowHeadings = (this.componentDefinition.showHeadings === undefined) ? true : this.componentDefinition.showHeadings;
    this.forcePageInfo = (this.componentDefinition.forcePageInfo === undefined) ? true :
      this.componentDefinition.forcePageInfo;
    this.showSelected = (this.componentDefinition.showSelected === undefined) ? true : this.componentDefinition.showSelected;
    const setShowSearch = (this.componentDefinition.showSearch === undefined) ? true : this.componentDefinition.showSearch;

    this.hideHeadings = (setShowHeadings === true) ? '' : 'hide-headings';
    this.hideSearch = (setShowSearch === true) ? '' : 'hide-search';

    this.componentDefinition.headerRotate = (this.componentDefinition.headerRotate === undefined) ? 'noRotate' :
      this.componentDefinition.headerRotate;

    this.componentDefinition.headerHeight = (this.componentDefinition.headerHeight === undefined) ? 'auto' :
      this.componentDefinition.headerHeight;

    this.componentDefinition.fontSize = (this.componentDefinition.fontSize === undefined) ? '14px' :
      this.componentDefinition.fontSize;

    this.componentDefinition.headerColor = (this.componentDefinition.headerColor === undefined) ? '#000' :
      this.componentDefinition.headerColor;

    this.headerWrapping = (this.componentDefinition.headerWrapping === undefined) ? true :
      this.componentDefinition.headerWrapping;

    document.documentElement.style.setProperty('--dt-fontSize', this.componentDefinition.fontSize);

    this.maxColumnWidth = 0;

    let debounce = SharedConstants.DEFAULT_SEARCH_DELAY;
    if (this.configService.clientConfig().searchDelay) {
      debounce = this.configService.clientConfig().searchDelay;
    }
    this.ngModelOptions = {debounce: 5000};
    this.dtsrch = '';

    this.device = 'lg';
    this.componentWidth = window.innerWidth;
    if (this.componentDefinition.fullWidth === false) {
      this.componentWidth = 283;
      this.device = 'xs';
    }

    if (this.componentWidth < 576) {
      this.device = 'xs';
    } else if (this.componentWidth >= 576 && this.componentWidth < 768) {
      this.device = 'sm';
    } else if (this.componentWidth >= 768 && this.componentWidth <= 992) {
      this.device = 'md';
    }

    this.selectedDocumentsRel = [];
    if (selectOnLoad) {
      this.selectedDocumentsRel = (this.fieldValue === undefined) ? [] : this.fieldValue;
    }

    this.initChildTemplate();

    this.rowClass = [];
    const responsiveClass = {
      lg: 'dt-desktop',
      md: 'dt-tablet',
      sm: 'dt-fablet',
      xs: 'dt-mobile'
    };

    const defaultMaxColumnScreen = {
      sm: 4,
      md: 6
    };


    if(this.componentDefinition.gridColumns === undefined || this.componentDefinition?.gridColumns.length === 0){
      if(this.componentDefinition.simpleColumns !== undefined && this.componentDefinition?.simpleColumns.length > 0){
          const gridCols : [any?] = [];
          for( const sCol of this.componentDefinition.simpleColumns){
            gridCols.push({
              displayName: sCol,
              type: 'string'
            });
          }
          this.componentDefinition.gridColumns = gridCols;
      }
    }


    let columnCount = 0;
    for (const [rowIndex, gridColumn] of this.componentDefinition.gridColumns.entries()) {
      // for dataArray dataSource
      // check if `field` option has no value, then assigned it to index{{key}}
      if(!gridColumn.field){
          const newIndex = 'index-' + rowIndex;
          this.componentDefinition.gridColumns[rowIndex].field = newIndex;
      }


      // this.maxColumnWidth += this.getWidth(gridColumn);
      const width = gridColumn.width || 1;
      this.maxColumnWidth += width;
      columnCount += (gridColumn.visible === undefined) ? 1 : gridColumn.visible;

      if (typeof gridColumn.responsive === 'object') {
        for (const key in gridColumn.responsive) {
          if (defaultMaxColumnScreen[key] > 0) {
            defaultMaxColumnScreen[key] -= width;
          }
        }
      }
    }


    // logger.info("Total Column Width is "+maxColumnWidth+" Number of columns is "+columnCount);
    this.sclExportService.headers = [];

    this.componentDefinition.gridColumns.forEach((val, i) => {
      const width = this.getWidth(val);
      const colClass = [];

      if (typeof val.responsive === 'object') {
        for (const key in val.responsive) {
          if (val.responsive.hasOwnProperty(key)) {
            colClass.push('dt-' + key + '-' + val.responsive[key]);

            if (defaultMaxColumnScreen[key] > 0) {
              defaultMaxColumnScreen[key] -= val.responsive[key];
            }
          }
        }
        // rowClass.push(colClass);
      } else {
        if (i > 0) {
          const colWidth = val.width;
          let sm = 0;
          let md = 0;
          if (defaultMaxColumnScreen.sm > 0) {
            defaultMaxColumnScreen.sm -= colWidth;
            sm = colWidth;
          }

          if (defaultMaxColumnScreen.md > 0) {
            defaultMaxColumnScreen.md -= colWidth;
            md = colWidth;
          }

          colClass.push(`dt-xs-0 dt-sm-${sm} dt-md-${md} dt-lg-${colWidth}`);
        }
      }
      this.rowClass.push(colClass);
    });

    this.dataTable = $(this.table.nativeElement);

    // this.table = null;
    const tableHeaders = '';
    this.dtcolumns = [];
    const columnFilter = [];
    const tblWidth = window.innerWidth - 168 - 10;

    const disabledDataType = ['boolean', 'array', 'object'];

    this.componentDefinition.gridColumns.forEach((val, i) => {
      this.columnIndex.push(i);

      if (val.enableColumnResizing === undefined) {
        if (!this.resizableCol) {
          this.excludeResizeCol.push(i);
        }
      } else {
        if (!val.enableColumnResizing) {
          this.excludeResizeCol.push(i);
        }
      }


      if (val.enableColumnMoving === undefined) {
        if (!this.componentDefinition.enableColumnMoving) {
          excludeMovableCol.push(i);
        }
      } else {
        if (!val.enableColumnMoving) {
          excludeMovableCol.push(i);
        }
      }

      const colWidth = this.getWidth(val);
      let dataField = val.field;
      let arrFilterField = '';
      if (val.filter === 'arrayFilter') {
        const fieldArr = val.field.split('.');

        if (fieldArr.length > 1) {
          arrFilterField = fieldArr.splice(-1, 1);
        } else {
          arrFilterField = undefined;
        }
        dataField = fieldArr.join('.');
      }

      const colVisible = (val.visible === undefined) ? true : val.visible;
      if (!colVisible) {
        this.componentDefinition.hiddenColumns.push(i);
      }

      if (val.sort?.direction !== undefined) {
        const isRowGroup = !!(val.sort.rowGroup);
        this.columnSort.push({
          field: dataField,
          index: i,
          direction: val.sort.direction,
          precedence: val.sort.precedence,
          rowGroup: isRowGroup
        });
      }


      this.columnSort.sort((a, b) => a.precedence - b.precedence);
      for (let j = this.columnSort.length - 1; j >= 0; j--) {
        if (this.columnSort[j].rowGroup) {
          this.rowGroup = true;
          rowGroupField = this.columnSort[j].field;
          break;
        }
      }


      const displayName = (val.displayName === undefined) ? dataField : val.displayName;
      // var w = colWidth/maxColumnWidth;
      const w = (colWidth / this.maxColumnWidth) * tblWidth;
      const wper = Math.round(((w - 16) / tblWidth) * 100);
      const disableClass = (disabledDataType.indexOf(val.type) < 0) ? '' : 'disableSort';

      if (this.dataSource === 'internal') {
        dataField = dataField.split('.')[dataField.split('.').length - 1];
      }


      let exportColVisible = colVisible;
      const visibleColExport = (typeof this.componentDefinition.exportSettings !== 'undefined'
              && typeof this.componentDefinition.exportSettings.exportVisibleOnly !== 'undefined' )
                ? this.componentDefinition.exportSettings.exportVisibleOnly : false;

      if( !visibleColExport ){
        exportColVisible = true;
      }

      if(exportColVisible){
        const colExport: any = {
          title: displayName,
          field: dataField
        };

        if ((val.filter && val.filter === 'dateFilter') || val.type === 'date') {
          val.type = 'date';
          val.filter = 'dateFilter';
        }

        if (val && val.filter && val.filter === 'arrayFilter') {
          colExport.arrayField = val?.arrayField || 'name';
          colExport.filter = 'arrayFilter';
        } else {
          switch (val.type) {
            case 'date':
              colExport.type = 'date';
              if (typeof this.componentDefinition.exportSettings !== 'undefined'
                && typeof this.componentDefinition.exportSettings.dateFormat !== 'undefined') {
                colExport.format = this.componentDefinition.exportSettings?.dateFormat || 'DD-MM-YYYY hh:mm a';
              } else {
                colExport.format = 'DD-MM-YYYY hh:mm a';
              }
              break;
            case 'url':
              colExport.type = 'url';
              colExport.href = '/' + val.href.replace(/^\/|\/$/g, '');
              break;
          }
        }

        if (val && val.cellFilter) {
          colExport.cellFilter = val.cellFilter;
        }

        if (val && val.urlExportMode) {
          colExport.urlExportMode = val.urlExportMode;
        }

        if (val && val.cellTemplate) {
          if (typeof this.componentDefinition.exportSettings !== 'undefined'
            && typeof this.componentDefinition.exportSettings.stripHTML !== 'undefined'
            && !this.componentDefinition.exportSettings.stripHTML ){
            colExport.cellTemplate = val.cellTemplate;
          } else {
            colExport.cellTemplate = val.cellTemplate.replace(/<[^>]*>?/gm, '');
          }
        }
        this.sclExportService.headers.push(colExport);
      }

      const rotateClass = (val.headerRotate === undefined) ? this.componentDefinition.headerRotate : val.headerRotate;

      const initColPriority = 10000;
      let colPriority = (i === 0) ? 1 : undefined;

      if (val.responsive && val.responsive.priority && i > 0) {
        colPriority = initColPriority + val.responsive.priority;
      }



      const fieldType = val.type;

      this.dtcolumns.push({
        data: dataField,
        name: val.field,
        title: displayName,
        // width: (w - 16) + 'px',
        width: wper + '%',
        defaultContent: '',
        responsivePriority: colPriority,
        type: val.type,
        visible: colVisible,
        filter: val.filter,
        className: this.rowClass[i].join(' ') + ' ' + disableClass + ' ' + rotateClass + ' colWidth-' + colWidth + ' index-' + i,
        orderSequence: ['asc', 'desc', ''],
        render: (data, type, row, meta) => {

          const sanitizeHTML = html => this.sanitizer.sanitize(SecurityContext.HTML, html);
          let cellHtml = sanitizeHTML(data) ?? '';

          if (val.cellTemplate) {
            // return parseCellTemplate(row, val.cellTemplate);
            // logger.info("In cellTemplate: Data is " + data);
            // We could use the meta field and the api interface to access the full data set
            // to fill in results and resultsCount but won't for now
            // Details start at https://datatables.net/reference/option/columns.render
            const handlebarsContext = {
              results: null,
              resultsCount: -1,
              resultsIndex: meta.row,
              queryResultDocument: row,
              ...this.contextParams
            };

            cellHtml = sclHandlebars.processHandlebars(val.cellTemplate,
              handlebarsContext, null);
            return this.cellTemplateServices.renderCell(cellHtml);
          } else {
            switch (val.filter) {
              case 'dateFilter':
                // const cellFilter = (val.cellFilter === undefined) ? 'date: "dd/MM/yyyy hh:mm a"' : val.cellFilter;
                // const dateFilters = eval('({' + cellFilter + '})');
                // $filter('date')(data, dateFilters.date);
                if ( data !== undefined ) {
                  let cellFilter = 'dd/MM/yyyy hh:mm a';
                  if (val.cellFilter) {
                    const dtFilterStr = _.split(val.cellFilter, '\'', 2);
                    if (dtFilterStr.length > 0 && dtFilterStr[1]) {
                      cellFilter = dtFilterStr[1];
                    }
                  }

                  cellHtml = this.datePipe.transform(data, cellFilter);
                } else {
                  cellHtml = '';
                }
                break;
              case 'numericFilter':
                const num = (!isNaN(parseFloat(data)) && isFinite(data)) ?
                  ((val.cellFilter) ? numeral(data).format(val.cellFilter) : numeral(data).value()) : '';
                cellHtml = '<div class="text-right">' + num + '</div>';
                break;
              case 'arrayFilter':
                cellHtml = this.sclUtilFilterService.arrayFilter(data, (arrFilterField === undefined) ? undefined : arrFilterField[0]);
                break;
              default:
                if (val.type === 'url') {
                  const url = val.href;
                  const urlOpen = (val.urlOpenIn) ? val.urlOpenIn : 'currentWindow';
                  let tmplHref = '<div class="linkText" id="' + row.documentId + '" > <a data-open="' + urlOpen + '" class="' +
                    this.fieldName + '_url" href="' + url + '">{{' + dataField + '}}</a></div>';
                  const resStr = 'result';
                  if (dataField === resStr) {
                    // use in sc-import-csv url return display
                    tmplHref = '<div class="linkText" id="' + row.documentId + '" > <a data-open="' + urlOpen + '" class="' +
                      this.fieldName + '_url" href="' + url + '">' + row[resStr] + '</a></div>';
                  }
                  const handlebarsContext = {
                    results: null,
                    resultsCount: -1,
                    resultsIndex: meta.row,
                    queryResultDocument: row,
                    ...this.contextParams
                  };
                  // return scope.sclUtilString.interpolate(tmplHref)(row);
                  cellHtml = sclHandlebars.processHandlebars(tmplHref,
                    handlebarsContext, null);
                  return `<div class="cell-data"><span class="cell-content">${cellHtml}</span></div>`;
                }
            }
          }
          cellHtml = cellHtml ?? '';
          return `<div class="cell-data"><span class="cell-content">${cellHtml}</span></div>`;
        }
      });

      let filterType = 'text';
      switch (fieldType) {
        case 'date':
          filterType = 'date';
          break;
      }

      columnFilter.push({
        column_number: i,
        filter_type: filterType,
        filter_delay: this.delayBeforeCallNum,
        date_format: 'yyyy-mm-dd'
      });
    });

    this.initialResizeCol = this.excludeResizeCol;

    this.dtSource = null;
    this.dtData = null;

    const loadDataTable = () => {
      const sortOrder = [];
      const comp = this;
      this.columnSort.forEach((val, i) => {
        sortOrder.push([val.index, val.direction]);
      });
      let rowGroupOptions;
      const exports = [];

      exportTypes.forEach((val, i) => {
        if (defExportTypes[val.toLowerCase()] !== undefined) {
          exports.push(defExportTypes[val.toLowerCase()]);
        }
      });

      if (this.rowGroup) {
        rowGroupOptions = {
          startRender: (rows, group) => {
            return '<i class="fa fa-plus-square"></i> ' + group + ' (' + rows.count() + ' rows)';
          },
          dataSrc: rowGroupField
        };
      }

      $.fn.dataTable.ext.errMode = 'throw';

      this.table = this.dataTable.DataTable({
        bProcessing: true,
        bServerSide: this.dataSource !== 'internal',
        dom: this.dataSource !== 'internal' ? 'rt' : 'rt<"dataTable-footer"<"info"i><"pagination"p>>',
        select: {
          style: this.componentDefinition.multiSelect ? 'multi' : 'single',
          info: false,
          // selector: 'tbody tr > td span:not(.cell-content)'
        },
        lengthMenu: this.lengthMenu, // this.componentDefinition.lengthMenu,
        autoWidth: false,
        order: sortOrder,
        rowGroup: rowGroupOptions,
        deferRender: true,
        colReorder: {
          realtime: false
        },
        responsive: false,
        pageLength: this.componentDefinition.rowsPerPage,
        language: {
          paginate: {
            previous: '&lt;',
            next: '&gt;'
          }
        },
        fnServerData: (sSource, aoData, fnCallback, pSelect?) => {
          this.prevSelectedDocumentsRel = [];

          this.dtSearch.search(sSource, aoData, ( searchResponse ) => {
            if( searchResponse.error){

              if(this.excludeColumnSort.indexOf( searchResponse?.sortField ) === -1){
                this.notificationService.printMessage(searchResponse.error ||
                  `Can't sort on this column as it has no values`, 'error');
                this.excludeColumnSort.push(searchResponse.sort);
              }
              searchResponse.prevResponse.draw = searchResponse.draw;
              fnCallback(searchResponse.prevResponse);
            }else{
              fnCallback(searchResponse);
            }

          }, pSelect);
        },
        columns: this.dtcolumns,
        initComplete: (settings: any) => {
          console.log('sc-datatable: Init Complete');

          const tableElement = $(this.dtWrapper.nativeElement).find('#' + this.fieldName);
          this.sclDatatableResponsiveService.responsiveInit(this.fieldName);

          // This code will changed btn-default to btn-raised
          $(this.dtWrapper.nativeElement.querySelectorAll('div.toolbar div.dt-buttons a')).map((index, elem) => {
            $(elem).removeClass('btn-default');
            $(elem).addClass('btn-raised');
          });

          this.generateColumnHeader();

          if(this.columnSearch){
            this.clearColumnSearch();
            this.generateColumnSearch();
          }

          this.dtEvents.selectedStatus(this);

          if (this.rowGroup) {
            const tblEle = $(tableElement);
            if (!tableElement.hasClass('rowGroup')) {
              tableElement.addClass('rowGroup');
            }

            tblEle.on('click', 'tr.group-start', (e: Event) => {
              const trGroupStart = e.target;
              tblEle.find(trGroupStart).nextUntil('tr.group-start').toggle();
              const expand = tblEle.find(trGroupStart).find('i').hasClass('fa-minus-square');
              if (expand) {
                tblEle.find(trGroupStart).find('i').removeClass('fa-minus-square').addClass('fa-plus-square');
              } else {
                tblEle.find(trGroupStart).find('i').removeClass('fa-plus-square').addClass('fa-minus-square');
              }

              tblEle.find('tbody tr').removeClass('group-odd');
              tblEle.find('tbody tr').removeClass('group-even');
              tblEle.find('tbody tr:visible:odd').addClass('group-odd');
              tblEle.find('tbody tr:visible:even').addClass('group-even');
            });


            tblEle.find('tbody tr').removeClass('group-odd');
            tblEle.find('tbody tr').removeClass('group-even');
            tblEle.find('tbody tr:visible:odd').addClass('group-odd');
            tblEle.find('tbody tr:visible:even').addClass('group-even');
          }
          // Fixed table WIDTH issue
          this.dtWrapper.nativeElement.querySelector('.dataTables_wrapper').classList.remove('form-inline');

          excludeMovableCol.forEach((val, i) => {
            const thElem = this.dtWrapper.nativeElement.querySelector('table thead').querySelectorAll('th')[val];
            $(thElem).off('mousedown');
          });

          const debounceResize = (ms: number, fn: any) => {
            let timer;
            return function () {
              clearTimeout(timer);
              const args = Array.prototype.slice.call(arguments);
              args.unshift(this);
              timer = setTimeout(fn.bind.apply(fn, args), ms);
            };
          };

          let prevWidth = 0;

          this.resizeObserver = new ResizeObserver(debounceResize(500, (entries, observer) => {
            this.zone.run(() => {
              const containerWidth = entries[0].contentRect.width;
              prevWidth = resizeHandler(prevWidth, containerWidth);
            });

            if (this.resizableCol) {
              this.dtEvents.initializeResize(this);
            }

          }));
          this.resizeObserver.observe(this.dtWrapper.nativeElement);

          this.initCompleted = true;
          this.detectChanges();
        },
        rowCallback(row, data, index) {
          // can't use arrow func, need to reference the api instance from datatable using this.api()
          const api = (this as any).api();
          const hand = document.createElement('div');

          hand.className = 'handler';
          row.querySelector('td:first-child').prepend(hand);
          hand.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const currentRow = $(e.target).parents().closest('tr');
            if (currentRow.hasClass('dt-parent')) {
              currentRow.removeClass('dt-parent');
              currentRow.next().remove();
            } else {
              comp.dtEvents.showChildRow(api, e, row);
            }
          });

          /*let selRow = $.grep(comp.selectedDocumentsRel, (n) =>{
            return n.documentId === data.documentId;
          });

          if( comp.componentDefinition.dataSource === 'dataArray' || comp.componentDefinition.dataSource === 'docArray' ){
            const pageInfo = api.page.info();
            const selectRowIndex = (pageInfo.page * pageInfo.length) + index;

            selRow = $.grep(comp.selectedDocumentsRel, (n) =>{
              return n.row === selectRowIndex;
            });

          }*/

          /*if (selRow.length > 0) {
            this.initDraw = true;
            api.row(index).select();
            comp.prevSelectedDocumentsRel.push(selRow[0]);
          }*/
        }
      });

      const resizeHandler = (prevWidth, containerWidth) => {
        if ((prevWidth - containerWidth < 20 && prevWidth - containerWidth > 0)) {
          return;
        }
        const prevScreen = this.screenDevice;

        this.divChildTemplate.nativeElement.classList.remove('dt-desktop', 'dt-tablet', 'dt-fablet', 'dt-phone');
        let hasHidden = 0;
        if (containerWidth >= 1024) {
          this.screenView = 'dt-desktop';
          this.screenDevice = 'lg';
          hasHidden = $(this.divChildTemplate.nativeElement).find('.dt-lg-0').length;
        } else if (containerWidth >= 768 && containerWidth < 1024) {
          this.screenView = 'dt-tablet';
          this.screenDevice = 'md';
          hasHidden = $(this.divChildTemplate.nativeElement).find('.dt-md-0').length;
        } else if (containerWidth >= 480 && containerWidth < 768) {
          this.screenView = 'dt-fablet';
          this.screenDevice = 'sm';
          hasHidden = $(this.divChildTemplate.nativeElement).find('.dt-sm-0').length;
        } else {
          this.screenView = 'dt-phone';
          this.screenDevice = 'xs';
          hasHidden = $(this.divChildTemplate.nativeElement).find('.dt-xs-0').length;
        }

        const dtObj = $(this.divChildTemplate.nativeElement).find('table.dataTable');

        if (hasHidden > 0) {
          dtObj.addClass('hasHidden');
        } else {
          dtObj.removeClass('hasHidden');
        }

        this.divChildTemplate.nativeElement.classList.add(this.screenView);

        const visibleHeaderCols = dtObj.find('thead tr:first-child th:visible').toArray();
        const hiddenHeaderCols = dtObj.find('thead tr:first-child th:hidden').toArray();

        // Adjusting columnWidth
        if (prevScreen !== this.screenDevice) {
          let totWidth = 0;
          const colWidth = [];
          visibleHeaderCols.forEach( (val, i) => {
            let regEx = `dt-${this.screenDevice}-([\\d])`;
            let c = $(val).attr('class').match(new RegExp(regEx));

            if (!c) {
              regEx = `colWidth-([\\d])`;
              c = $(val).attr('class').match(new RegExp(regEx));
            }

            const w = (c) ? c[1] : 1;
            totWidth += (w * 1);
            colWidth.push(w);
          });


          visibleHeaderCols.forEach( (val: any, i: number) => {
            const cWidth = (colWidth[i] / totWidth) * 100;
            $(val).width(cWidth + '%');
          });

        }

        this.dtEvents.markLastColumn(dtObj);

        if (hiddenHeaderCols.length > 0) {
          dtObj.find('.dt-child-row td').attr('colspan', visibleHeaderCols.length);
        } else {
          dtObj.find('.dt-child-row td ul').empty();
          dtObj.find('.dt-parent').removeClass('dt-parent');
        }

        document.documentElement.style.setProperty('--dt-screen-view', this.screenView);
        return containerWidth;
      }

      let searchWaitInterval = null;

      const childTempElem = $(this.dtWrapper.nativeElement.querySelector('.dataTables_filter input'));
      childTempElem.unbind();
      childTempElem.bind('keyup', (e: Event) => {
        const childTempElemInput = e.target;
        clearTimeout(searchWaitInterval);
        searchWaitInterval = setTimeout( () => {
          const searchTerm = $(childTempElemInput).val();
          this.table.search(searchTerm).draw();
        }, this.delayBeforeCallNum);
      });

      this.table.on('draw', () => {
        const api = this.table; // You already have the instance
        console.log(`sc-datatable: Draw`);
        this.isDrawing = true;

        if (this.dataSource !== 'external') {
          const pageElem = $(this.dtWrapper.nativeElement.querySelector('.dt-info > .page_num'));
          pageElem.unbind('change');
          pageElem.bind('change', (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            const pageElemInput = e.target;
            const pageNum: number = $(pageElemInput).val() * 1;
            if (!isNaN(pageNum)) {
              this.pagination.current_page = pageNum > this.pagination.last_page ? this.pagination.last_page : pageNum;
              api.page(pageNum - 1 ).draw('page');
            }
          });
        }

        this.resetIntervalTimer(api);

        if (this.resizableCol) {
          // table resizing grip size adjust height
          const tblHeight = $(this.dtWrapper.nativeElement).find('#' + this.fieldName).height() + 12; // add padding
          $(this.dtWrapper.nativeElement).find('#' + this.fieldName).parent().find('.JCLRgrips').find('.JCLRgrip').height(tblHeight);
        }

        // logger.info("Datatable Draw Complete.");
        if (this.dataSource === 'internal') {
          $('div[id="' + this.fieldName + '_processing"]').css('display', 'none');
          $(this.dtWrapper.nativeElement).find('.dataTables_empty').text('No data available in table');
          this.utilSharingNgService.fnPassedDataObject(this.componentDefinition.linkFunction[0],
            'Processing_' + this.componentDefinition.linkFunction[0], true);
          if (this.isFirstLoad) {
            this.isFirstLoad = false;
            setTimeout(() => {
              this.utilSharingNgService.fnCallFunction(this.fieldName, 'eventReloadDatatable', null, null);
            });
          }
        }

        const totalHits = this.dtSearch.totalHits;
        if( totalHits !== this.pagination.total_items) {
          this.pagination.total_items = totalHits;
          const rowsPerPage = (this.componentDefinition.rowsPerPage) ? this.componentDefinition.rowsPerPage : 10;
          this.initPagination(rowsPerPage);
        }

        this.dtEvents.selectedStatus(this);

        const selectedDocs = [];
        const rows = api.rows().data().toArray();

        for(const [index, selectedDoc] of rows.entries()){
            const selRow = $.grep(comp.selectedDocumentsRel, (n) =>{
              return n.documentId === selectedDoc.documentId;
            });

            if(selRow.length > 0){
              selectedDocs.push(index);
            }
        }

        api.rows(selectedDocs).select();
        Promise.resolve().then(() => {
          this.isDrawing = false;
          this.isFromDocumentUpdate = false;
        });

        this.dtEvents.draw(this);
      });

      this.table.on('column-reorder', (e: Event, settings: any, details: any) => {
        this.dtEvents.columnReorder(this, details);
      });

      this.table.on('processing.dt', (e: Event, settings: any, processing: boolean) => {
        if ( processing) {
          $(comp.dtWrapper.nativeElement).find('.footer-processing').addClass('show');
        } else {
          $(comp.dtWrapper.nativeElement).find('.footer-processing').removeClass('show');
        }
      });

      this.table.on('order.dt', () => {
        this.dtEvents.order(this);
      });

      this.table.on( 'user-select', ( e, dt, type, cell, originalEvent ) => {

        if ( window.getSelection().toString() !== '' || originalEvent.target.tagName.toLowerCase() === 'a') {
          e.preventDefault();
        }

        if( this.disabled ){
          e.preventDefault();
        }
      });

      this.table.on('select', (e, dt, type, indexes) => {
        const data = this.table.rows(indexes).data()[0];
        this.selectInfo = {
          type,
          indexes,
          data
        };

        delete comp.fromEvent;

        if (!this.shouldSelectRow) {
          return;
        }

        if (this.childDocumentInfo && this.modifiedFieldService.hasChanged(this.childDocumentInfo.documentId)) {

          const succFunc = async () => {
            await this.saveDocumentList(
              () => comp.resetSelectedRowAfterSave(comp.selectInfo),
              () => {}
            );
          };

          const discardFunc = () => {
            this.modifiedFieldService.removeModifiedDocumentFields(this.childDocumentInfo.documentId);
            this.shouldSelectRow = true;
            comp.resetSelectedRowAfterDiscard(this.selectInfo);
          };

          const cancelFunc = () => {
            console.log('Cancelling navigation due to unsaved changes.');
          };

          if (!this.isSaving) {
            this.modalService.showDialog('Save Changes?', 'WARNING', succFunc, cancelFunc, discardFunc);
          }

          return;
        }

        if (typeof dt === undefined) {
          return;
        }

        this.dtEvents.select(this, indexes);
      });

      this.table.on('deselect', (e, dt, type, indexes) => {

        const data = comp.table.rows(indexes).data()[0];

        comp.lastSelectInfo = {
          type,
          indexes,
          data
        };

        if (comp.fromEvent === CONFIRM_FROM_DIALOG_CANCEL) {
          delete comp.fromEvent;
          return;
        }

        function doSelect() {
          if (comp.selectInfo) {
            comp.dtEvents.select(comp, comp.selectInfo?.indexes);
          }
        }

        function doDeselect() {
          comp.dtEvents.deselect(comp, indexes);
          if (comp.selectRef) {
            comp.selectRef.options.forEach((optionData) => optionData.deselect());
          }
        }

        if (this.childDocumentInfo && this.modifiedFieldService.hasChanged(this.childDocumentInfo.documentId)) {

          this.shouldSelectRow = false;

          const succFunc = async () => {
            comp.resetSelectedRowAfterSave(comp.selectInfo);
            await this.saveDocumentList(
              () => {
                comp.shouldSelectRow = true;
                doDeselect();
                // doSelect();
              },
              (err) => {
                console.log(err);
                comp.shouldSelectRow = true;
                comp.resetSelectedRowAfterCancel(comp.lastSelectInfo);
              }
            );
          };

          const discardFunc = () => {
            this.modifiedFieldService.removeModifiedDocumentFields(this.childDocumentInfo.documentId);
            this.shouldSelectRow = true;
            doDeselect();
            doSelect();
            comp.resetSelectedRowAfterDiscard(this.selectInfo);
          };

          const cancelFunc = () => {
            console.log('Cancelling navigation due to unsaved changes.');
            this.shouldSelectRow = true;
            comp.resetSelectedRowAfterCancel(this.lastSelectInfo);
          };

          delete this.selectInfo;

          if (!this.isSaving) {
            this.modalService.showDialog('Save Changes?', 'WARNING', succFunc, cancelFunc, discardFunc);
          }
          return;
        }

        doDeselect();

      });

      this.table.on('click', 'tbody tr', (e) => {
        if (e.shiftKey || e.ctrlKey || e.metaKey) {
          e.stopPropagation();
        }
      });

      /** dblClick Event */
      this.table.on('dblclick', 'tbody tr', (e: Event) => {
        e.stopPropagation();
        if (that.dataSource !== 'internal') {
          return;
        }

        $(this).addClass('selected');

        const rowObject = [];
        const tdElem = (e.target as HTMLElement).querySelectorAll('td');
        tdElem.forEach((elem, index) => {
          rowObject.push($(elem).text());
        });

        this.utilSharingNgService.fnPassedDataObject(this.fieldName, 'PushedRowValue', rowObject);
        setTimeout(() => {
          this.utilSharingNgService.fnCallFunction(this.componentDefinition.linkFunction[0], 'eventDoubleClickRowValue', null, null);
        }, 100);
      });

      $(this.dtWrapper.nativeElement).find(this.dataTable).find('tbody')
        .on('click', 'a.' + this.fieldName + '_url', (e: KeyboardEvent) => {
        const urlElement = e.target as HTMLElement;
        if (e.shiftKey || e.ctrlKey || e.metaKey) {
          return;
        } else {
          const openMode = $(urlElement).data('open') ? $(urlElement).data('open') : 'currentWindow';
          const url = $(urlElement).attr('href');
          if (openMode !== 'currentWindow') {
            e.stopPropagation();
            e.preventDefault();
            comp.sclUtilUrlService.openLink(url, openMode, comp);
            return false;
          } else {
            routerService.navigateByUrl(url);
          }
        }

      });
    };

    // Start timer
    const startBackgroundTimer = () => {
      this.resetIntervalTimer(this.table);
    };

    // Stop timer
    const stopBackgroundTimer = () => {
      clearInterval(this.refreshIntervalTimer);
    };

    if (!backgroundRefresh) {
      // Active
      window.addEventListener('focus', startBackgroundTimer);

      // Inactive
      window.addEventListener('blur', stopBackgroundTimer);
    }

    loadDataTable();

    const that = this;

    const eventListSub = this.broadcastService
      .on(SharedConstants.EVENT_LIST_NAME)
      .subscribe(data => {
        if (data && data[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME]) {
          const value = data[SharedConstants.ON_CHANGE_FILTER_EVENT_NAME];
          if (value &&
            value[SharedConstants.RULESET_AFFECTED_FIELD_NAME] === this.componentDefinition.name &&
            value[SharedConstants.RULESET_AFFECTED_DOCUMENT_ID] === this.document.documentId) {

            const compDef = {...this.componentDefinition};
            compDef.filter = value[SharedConstants.RULESET_NEW_FILTER];
            this.componentDefinition = compDef;
            // reloadBasicDataTables();
            this.reload();
          }
        }
      });
    this.subs.add(eventListSub);

    const refreshSub = this.broadcastService.on(SharedConstants.EVENT_REFRESH_COMPONENT_NAME).subscribe(data => {
      if (data?.fieldName === this.componentDefinition.name && data?.documentId === this.document.documentId) {
        this.reload();
      }
    });
    this.subs.add(refreshSub);

    const updatedSub = this.broadcastService
      .on('document:updated')
      .subscribe(async data => {
        this.isFromDocumentUpdate = true;
        this.lastUpdatedDoc = _.first(data);

        // document:updated calls twice, this checks the previous updated data is the same document.
        // if the same document, update prevUpdateDoc to undefined then Stop execution
        if(this.prevUpdatedDoc && this.prevUpdatedDoc === this.lastUpdatedDoc.documentId ){
          this.prevUpdatedDoc = undefined;
          return;
        }

        if(this.lastUpdatedDoc){
          // assign updated data documentId to `prevUpdatedDoc` to use on next call
          this.prevUpdatedDoc = this.lastUpdatedDoc.documentId;
        }

        if (this.hasChildDoc) {
          this.isTemplate = false;
          const updatedDoc = data.find(doc => doc.documentId === this.childDocumentInfo?.documentId);
          if( updatedDoc?.documentId === this.childDocumentInfo?.documentId){
            this.reloadBasicDataTables();
          }
        }

        if (!data) {
          return;
        }

        if (data[0].documentId === this.document.documentId) {
          this.document = data[0];
        }

        const loadedDoc = this.selectedDocumentsRel && this.selectedDocumentsRel.length ? this.selectedDocumentsRel[0] : null;
        const childDocumentId = loadedDoc?.documentId ? loadedDoc?.documentId : this.childDocumentInfo?.documentId;
        if (childDocumentId === data[0].documentId) {
          if (childDocumentId && (!this.componentDefinition.templateTarget ||
            this.componentDefinition.templateTarget === 'currentWindow')) {
            this.isUpdated = true;
            await this.dataService.getDocument(childDocumentId)
              .then((childSource) => {
                if(this.fromEvent !== CONFIRM_FROM_DIALOG_SAVE){
                  this.selectedChildDocId = childDocumentId;
                  this.getTemplateName(childSource);
                  this.loadTemplate(childSource.systemHeader.templateId, childDocumentId, true);
                }
              });

            this.selectedTemplate = undefined;
            this.detectChanges();
          }
        }

      });
    this.subs.add(updatedSub);

    const destroySub = this.broadcastService
      .on('$destroy')
      .subscribe(data => {
        clearInterval(this.refreshIntervalTimer);
      });
    this.subs.add(destroySub);

    if (this.hasChildDoc) {
      const docId = this.document.documentId ? this.document.documentId : this.template.documentId;

      this.parentDoc = this.document;
      this.parentId = docId;
      const isNew = this.sclUtilDocumentService.isNew(this.document);
      if (isNew) {
        this.isTemplate = true;
      }

      this.detectChanges();
    }

    // scope.$watchCollection('doc[fieldName]', function(e) {
    const valueChange = new Observable(observer => {
      observer.next(this.fieldValue);
      observer.complete();
    });

    valueChange.subscribe({
      next: e => {
        // logger.info("In Watch on data field dontWatch="+scope.dontWatch+ " " + JSON.stringify(e));
        if(!this.initCompleted) return;

        if (!this.dontWatch) {
          this.selectedDocumentsRel = (e === undefined || e === null) ? [] : e;
          if (this.fieldValue && this.fieldValue.length === 0) {
            delete this.fieldValue;
          }
        } else if ((e === undefined || e === null || e === []) && !this.dontWatch) {
          this.selectedDocumentsRel = [];
          if (this.fieldValue && this.fieldValue.length === 0) {
            delete this.fieldValue;
          }
          this.selectAllBox = false;
        }
        this.reloadBasicDataTables();
        this.dontWatch = false;
      }
    });

    const clearTable = () => {
      this.utilSharingNgService.fnPassedDataObject(this.fieldName, 'DataListObject_' + this.fieldName, null);
      if (this.table) {
        this.table.clear().draw();
      }
      $('div[id="' + this.fieldName + '_processing"]').css('display', 'block');
      $(this.dtWrapper.nativeElement).find('.dataTables_empty').text('Loading...');
    };

    const eventReloadDatatable = () => {
      // ** use fnCallFunction to call scope.eventReloadTable() function in sc-audit*/
      clearTable();
      this.utilSharingNgService.fnCallFunction(this.componentDefinition.linkFunction[0], 'eventReloadTable', null, null);
      // logger.info(scope,$rootScope,scope.reloadDataTables);
    };
    // Register function here to be called in other components
    if (this.dataSource === 'internal') {
      this.utilSharingNgService.fnRegisterFunctions([{name: 'eventReloadDatatable', fn: eventReloadDatatable}]
        , this.fieldName, this.document.documentId);
    }

    const reloadDataTables = () => {
      if (this.table) {
        this.table.clear().draw();
        this.table.rows.add(this.utilSharingNgService.fnGetDataObject(this.fieldName, 'DataListObject_' + this.fieldName)
          .objectDataValue).draw(false); // Add new data
        // ** close loading modal*/
        $('#idOpenModalLoading button').click();
      }
    };

    // **This is watched function for getSharedData DataListObject*/
    const dataListObject = new Observable(observer => {
      observer.next(this.clientRulesService.getSharedValue('DataListObject_' + this.fieldName));
      observer.complete();
    });
    dataListObject.subscribe({
      next: change => {
        const newValue = (change as any); // change.newValue;
        if (newValue) {
          if (!(newValue.objectDataValue === null)) {
            reloadDataTables();
          }
        }
      }
    });

    this.isReloadOnce = true;
    if (this.dataSource === 'internal') {
      const updatedSub2 = this.broadcastService
        .on('document:updated')
        .subscribe(obj => {
          if (obj) {
            this.isReloadOnce = !this.isReloadOnce;
            if (this.isReloadOnce) {
              this.utilSharingNgService.fnCallFunction(this.fieldName, 'eventReloadDatatable', null, null);
            }
          }
        });
      this.subs.add(updatedSub2);
    }

    // begin logic for listening audit-table emit data
    const watchDataListObject = this.broadcastService.on('DataListObject_' + this.fieldName).subscribe((newValue: any) => {
      if (newValue) {
        if (!(newValue.objectDataValue === null)) {
          reloadDataTables();
        }
      }
    });
    this.subs.add(watchDataListObject);
    // end logic for listening audit-table emit data

    const loadedSub = this.broadcastService.on(ClientConstants.DOCUMENT_LOADED).subscribe((data: any) => {
      if (data && data.documentData && data.documentData.template) {
        const docListId = data?.formParameters?.unsavedDocumentListId;
        const parentId = data?.formParameters?.hierarchyInfo?.parentDocumentId;
        const documentId = data?.documentData?.documentId;
        if (this.childDocumentInfo && parentId === this.document?.documentId && docListId === this.formParameters.unsavedDocumentListId) {
          this.childDocumentInfo.documentId = documentId;
        }
      }
    });
    this.subs.add(loadedSub);
  }

  reloadBasicDataTables() {
    setTimeout(() => {
      // console.log('Loading Datatable, Instantiated jQuery Datatable Library: ', $.fn.DataTable.isDataTable(that.dataTable));
      // if ($.fn.DataTable && $.fn.DataTable.isDataTable(that.table)) {
      if (this.table) {
        this.table.draw();
      }
    });
  }

  clearColumnSearch() {
    const eleChildTemp = $(this.dtWrapper.nativeElement);
    eleChildTemp.find('.columnSearch').remove();
  };

  generateColumnSearch( ) {
    const disabledSearchType = ['boolean', 'array', 'object', 'date', 'number'];
    const tableElement = $(this.dtWrapper.nativeElement).find('#' + this.fieldName);
    const eleChildTemp = $(this.dtWrapper.nativeElement);

    const tr = this.renderer.createElement('tr');
    this.renderer.addClass(tr, 'columnSearch');

    this.componentDefinition.gridColumns.forEach((val, i) => {
      const isHidden = this.componentDefinition.hiddenColumns.includes(i);
      if (val.visible !== false || !isHidden) {
        const disabledType = (disabledSearchType.indexOf(val.type) < 0) ? '' : 'disableSort';
        // logger.info('Column[' + i + '] - type=' + val.type + ' disabledType=' + disabledType);
        const colInputId = this.componentDefinition.name + '_colInput_' + i;
        const th = this.renderer.createElement('th');
        th.className = this.rowClass[i].join(' ');
        const defaultValue = this.columnSearchList ? (this.columnSearchList[i] ?? '') : '';
        const input = `<div class="mdl-col-search">` +
          `<i class="material-icons">filter_list</i> ` +
          `<input class="sc-colInput" ` +
          `type="text" id="${colInputId}" value="${defaultValue}" data-index="${i}" data-label="${val.displayName}">` +
          `</div>` +
          `<label class="sc-filter-reset-button">` +
          `<i class="material-icons">close</i>` +
          `</label>`;
        if (!disabledType) {
          th.innerHTML = input;
        }
        tr.append(th);
      }
    });

    tableElement.find('thead').append(tr);
    let colSearchWaitInterval = null ;
    eleChildTemp.find('.sc-colInput').unbind('keyup');
    eleChildTemp.find('.sc-colInput').on('keyup', (e: Event) => {
      const inputElem = e.target;
      let searchVal = $(inputElem).val();
      const ind = $(inputElem).data('index');
      const label = $(inputElem).data('label');
      clearTimeout(colSearchWaitInterval);
      colSearchWaitInterval = setTimeout(() => {
        if(searchVal.length > 100){
          searchVal = searchVal.substring(0, this.SEARCH_LENGTH_LIMIT);
          logger.info(`Column "${label}": Search Text has been truncated to '${searchVal}'.`);
        }
        this.columnSearchList[ind] = searchVal;
        this.table.column(ind).search(searchVal).draw();
      }, this.delayBeforeCallNum);
    });

    eleChildTemp.find('.sc-filter-reset-button').unbind('click');
    eleChildTemp.find('.sc-filter-reset-button').on('click', (e: Event) => {
      const resetBtnElem = e.target;
      $(resetBtnElem).parent().find('input').val('');
      const ind = $(resetBtnElem).parent().find('input').data('index');
      this.table.column(ind).search('').draw();
    });
  }

  generateColumnHeader() {
    const tableElement = $(this.dtWrapper.nativeElement).find('#' + this.fieldName);

    const headerColor = this.componentDefinition.headerColor;
    tableElement.find('thead').find('th').each((key, item) => {
      const text = $(item).find('> div.th-wrapper').data('item') || $(item).text();

      $(item).wrapInner(`<div class="th-wrapper" data-item="${text}" ><div class="rotate" style="color: ${headerColor};"></div></div>`);
      $(item).height(this.componentDefinition.headerHeight);
      if (this.resizableCol) {
        $(item).append(`<div class='dt-resizer'><div></div></div>`);
      }
    });
  }

  watchDocument() {
    const createWatchDocument = () => {
      const watchFields = this.componentDefinition.updateWatchFields || [];

      if(this.componentDefinition.dataSourceName){
        watchFields.push( 'document.' + this.componentDefinition.dataSourceName);
      }
      for (const val of watchFields) {
        const field = val.replace('document.', '');
        const fieldSub = this.changedDocumentService.watch(field, this.document.documentId)
          .subscribe((newValue: any) => {
          this.contextParams.document[field] = newValue;
          this.onClickReload();
        });

        this.subs.add(fieldSub);
      }

      const watchDoc = this.changedDocumentService.watchDocument(this.document.documentId).subscribe((newValue: any) => {
        this.contextParams.document = newValue;
      });

      this.subs.add(watchDoc);


      /*const scopeSub = this.changedDocumentService.watchDocument(this.document.documentId).subscribe((newValue: any) => {

        const oldValue = this.contextParams.document;
        const watchFields = this.componentDefinition.updateWatchFields || [];
        for (const val of watchFields) {
          const field = val.replace('document.', '');

          const old = _.get(oldValue, field);
          const newV = _.get(newValue, field);
          if (old !== newV) {
            this.contextParams.document = newValue;
            this.onClickReload();
          }
        }
      });

      this.subs.add(scopeSub);*/
    };

    createWatchDocument();
  }

  getWidth(val) {
    let colVis = true;
    if (val.visible !== undefined) {
      colVis = val.visible;
    }
    // logger.info("Device Size is "+this.device+" : " + ((colVis) ? "visible" : "not visible") +
    //    " width=" + val.width + " responsive width=" + ((typeof val.responsive === "object") ?
    //    val.responsive[this.device] : "NOT-DEFINED"));
    if (!colVis) {
      // if column is not visible, return `1` by default. If has `width` return the width and should return 1 if width is 0.
      return val.width !== undefined ? ( val.width || 1) : 1;
    }
    if (typeof val.responsive === 'object') {
      if (val.responsive[this.device] !== undefined) {
        return val.responsive[this.device];
      }

    }
    if (!val.width) {
      return 1;
    } else {
      return val.width;
    }
  }

  onClickReload() {
    if (this.dataSource === 'internal') {
      this.utilSharingNgService.fnCallFunction(this.fieldName, 'eventReloadDatatable', null, null);
    } else {
      const sortOrder = [];
      this.columnSort.forEach((val, i) => {
        sortOrder.push([val.index, val.direction]);
      });
      if (this.table) {
        setTimeout( () => {
          this.table.order(sortOrder).draw();
        });
      }
    }
  }

  loadDefaultFields() {
    if (this.parentId) {
      const def = this.selectedTemplate.default;
      const defField = this.selectedTemplate.fieldType;
      if (def && this.parentDoc) {
        const data = this.document;
        // const defObj = {parentDoc: {}};
        const defObj = {};
        _.map(def, (value, field) => {
          if (value === 'documentId') {
            const fieldType = (defField && defField[field]) ? defField[field] : 'relatedDocument';
            if (fieldType !== 'string') {
              defObj[field] = [{
                documentId: data.documentId,
                name: data.systemHeader.summaryName || 'Parent: ' + this.document.documentId
              }];
            } else {
              defObj[field] = data.documentId;
            }
          } else {
            // To get nested data from the objects
            const clone = _.get(data, value);

            const fieldType = (defField && defField[field]) ? defField[field] : typeof clone;

            if (fieldType === 'relatedDocument') {
              if ( typeof clone !== 'object') {
                defObj[field] = [{
                  documentId: clone
                }];
              } else {
                const {documentId, name} = clone;
                defObj[field] = [{
                  documentId: documentId,
                  name: name
                }];
              }
            } else if (fieldType === 'object') {
              defObj[field] = clone;
            } else if (fieldType === 'string') {
              // If fieldType was set to string and the source is object, it will stringify
              if (typeof clone === 'object') {
                defObj[field] = JSON.stringify(clone);
              } else {
                defObj[field] = clone;
              }
            } else {
              defObj[field] = clone;
            }

          }
        });


        this.defaultFields = defObj;

      }
    }
  }

  loadTemplate(templateId, documentId, isNoReload?) {
    this.showChildDocTitle = true;

    this.templateId = documentId ? documentId : templateId;
    this.selectedChildDocId = documentId;
    this.selectedChildTplId = templateId;

    this.childDocumentInfo = this.documentListService.getDocumentInfoItem(this.formParameters.unsavedDocumentListId, documentId);
    this.childDocumentInfo.documentId = documentId;
    this.childDocumentInfo.templateId = templateId;

    // this.noChildDocLink = this.selectedChildDocId ? false : true;
    if (!isNoReload) {
      this.changeTemplate = !this.changeTemplate;
    }
    this.detectChanges();
  }

  loadChild(selectedData) {
    if(selectedData.systemHeader){
      const templateId = selectedData.systemHeader.templateId;
      const documentId = selectedData.documentId;

      const isLoadedDocument = this.changedDocumentService.isLoadedDocument(documentId, this.formParameters.unsavedDocumentListId);

      if (!isLoadedDocument) {
        this.selectedTemplate = undefined;
        this.showChildDocTitle = true;
        this.selectedChildDocId = documentId;
        this.getTemplateName(selectedData);
        this.loadTemplate(templateId, documentId);
      }
    }
  }

  initChildDoc(documentId) {
    const childDocumentList = this.documentListService.setupDocumentListId();

    const childScope = {
      parentDocumentId: this.document.documentId,
      defaultFields: this.defaultFields,
      unsavedDocumentListId: childDocumentList.documentListId,
      modalTitle: this.componentDefinition.label,
      hierarchyInfo: childDocumentList.hierarchyInfo,
      selectedDocumentId: documentId
    };

    return childScope;
  }

  selectChange(event, item) {

    // filter the selectChange here, click and touch event should execute 1 time only
    if( (event.type === 'click' && this.isMobileDetect) ||
      (event.type !== 'click' && !this.isMobileDetect)
    ){
      return;
    }

    const comp = this;
    delete comp.fromEvent;

    this.selectedTemplate = item;

    function doSelectChange(reload = false) {
      comp.dtEvents.deselectAll(comp);

      comp.changeTemplateToogle = true;

      const templateTarget = comp.componentDefinition.templateTarget;
      const targetTypes = ['newWindow', 'popup', 'overlay'];

      if (templateTarget === 'currentWindow' || !targetTypes.includes(templateTarget)) {
        comp.showChildDocTitle = false;
        comp.loadDefaultFields();
        comp.templateName = comp.selectedTemplate.name;
        // comp.selectedChildDocId = null;
        comp.loadTemplate(comp.selectedTemplate.templateId, '', reload);
      } else {
        comp.loadDefaultFields();
        const url = 'form/' + comp.selectedTemplate.templateId;
        const childScope = comp.initChildDoc(null);

        comp.sclUtilUrlService.openLink(url, comp.componentDefinition.templateTarget, childScope);
      }

      comp.detectChanges();
    }

    if (this.childDocumentInfo && this.modifiedFieldService.hasChanged(this.childDocumentInfo.documentId)) {

      const succFunc = async () => {

        const backupChildDocInfo = comp.childDocumentInfo;
        delete comp.childDocumentInfo;

        await this.saveDocumentList(
           () => {
            comp.selectedDocumentsRel = [];
            comp.changedDocumentService.valueChanged(comp, comp.selectedDocumentsRel, comp.registeredControlName);

            comp.shouldUpdateTemplateName = false;
            comp.fromEvent = CONFIRM_FROM_DIALOG_SAVE;

            doSelectChange(true);
          },
          () => {
            comp.childDocumentInfo = backupChildDocInfo;
          }
        );

      };

      const discardFunc = () => {
        this.modifiedFieldService.removeModifiedDocumentFields(this.childDocumentInfo.documentId);
        doSelectChange();
      };

      const cancelFunc = () => {
        console.log('Cancelling navigation due to unsaved changes.');
      };

      this.modalService.showDialog('Save Changes SelectChange?', 'WARNING', succFunc, cancelFunc, discardFunc);

      return;
    }

    doSelectChange();

  }

  resetSelectedRowAfterDiscard(selectedInfo?) {
    this.selectedDocumentsRel = selectedInfo ? [{
      documentId: selectedInfo?.data?.documentId,
      name: selectedInfo?.data?.name
    }] : [];
    this.changedDocumentService.valueChanged(this, this.selectedDocumentsRel, this.registeredControlName);
    this.fromEvent = CONFIRM_FROM_DIALOG_DISCARD;
  }

  resetSelectedRowAfterSave(selectedInfo?) {
    this.selectedDocumentsRel = selectedInfo ? [{
      documentId: selectedInfo?.data?.documentId,
      name: selectedInfo?.data?.name
    }] : [];
    this.changedDocumentService.valueChanged(this, this.selectedDocumentsRel, this.registeredControlName);
    this.fromEvent = CONFIRM_FROM_DIALOG_SAVE;
  }

  resetSelectedRowAfterCancel(selectedInfo?) {
    $(this.dtWrapper.nativeElement).find('#' + this.fieldName + ' tbody tr').removeClass('selected');

    this.table.rows()[0].forEach((val, i) => {
      const rowData = this.table.rows(i).data()[0];
      if (rowData.documentId === selectedInfo.data.documentId) {
        $(this.dtWrapper.nativeElement).find('#' + this.fieldName + ' tbody').children().eq(i).addClass('selected');
        this.shouldSelectRow = false;
        this.fromEvent = CONFIRM_FROM_DIALOG_CANCEL;
        this.table.rows(i).select();
      }
    });

    this.dtEvents.selectedStatus(this);

  }

  onCloseChildDocument() {
    const comp = this;

    const resetChildDoc = () =>{
      this.changeTemplateToogle = false;
      this.selectedChildDocId = null;
      this.showChildDocTitle = false;
      this.selectedTemplate = undefined;
      // comp.resetSelectedRowAfterDiscard(this.selectInfo);
      this.detectChanges();
    }

    if (this.childDocumentInfo && this.modifiedFieldService.hasChanged(this.childDocumentInfo.documentId)) {

      const succFunc = async () => {
        const backupChildDocInfo = comp.childDocumentInfo;
        delete comp.childDocumentInfo;

        await this.saveDocumentList(
          ( result )=> {
            const newChild = [...result.data].pop();
            comp.getTemplateName(newChild);

            // comp.resetSelectedRowAfterSave(comp.selectInfo);
            comp.shouldUpdateTemplateName = true;
            comp.selectedChildDocId = newChild.documentId;
            this.selectedTemplate = undefined;
            this.deselectAll();
          },
          () => {
            comp.childDocumentInfo = backupChildDocInfo;
          }
        );

      };

      const discardFunc = () => {
        this.modifiedFieldService.removeModifiedDocumentFields(this.childDocumentInfo.documentId);
        this.shouldSelectRow = true;
        this.selectedDocumentsRel = [];
        this.deselectAll();
        resetChildDoc();
      };

      const cancelFunc = () => {
        console.log('Cancelling navigation due to unsaved changes.');
      };

      this.modalService.showDialog('Save Changes?', 'WARNING', succFunc, cancelFunc, discardFunc);

      return;
    }else{
      this.selectedDocumentsRel = [];
      this.deselectAll();
      resetChildDoc();
    }

  }

  selectPageLengthChange(length) {
    this.initPagination(length);
    this.dtEvents.pageLength(length, this);
  }

  search(event) {
    this.dtSearch.searchBox(event, this);
  }

  reload() {
    this.dtEvents.reload(this);
  }

  selectPage(item) {
    const selectType =  ( !this.allSelect && this.pageSelect ) ? 'page' : 'all';

    const checked = item.target.checked;
    if (checked) {
      this.selectAll(selectType);
    } else {
      this.deselectAll();
    }
  }

  selectAll(item) {
    this.dtEvents.selectAll(this, item);
  }

  deselectAll(){
    this.dtEvents.deselectAll(this);
  }

  showSelectedItems(){
    this.isSelectionView = !this.isSelectionView;
    this.dataSource = this.isSelectionView ? 'docArray' : 'filter';

    this.reload();
  }

  getTemplateName(selectedData) {
    const templateId = selectedData.systemHeader.templateId;

    if (selectedData.name) {
      this.templateName = selectedData.name;
    } else if (selectedData.systemHeader && selectedData.systemHeader.summaryName) {
      this.templateName = selectedData.systemHeader.summaryName;
    } else if (templateId) {
      this.dataService.getDocument(templateId)
        .then((data) => {
          this.templateName = data.name;
          this.detectChanges();
        });
    }
  }

  resetIntervalTimer(datatable) {
    clearInterval(this.refreshIntervalTimer);
    if (this.refreshInterval) {
      // tslint:disable-next-line:only-arrow-functions
      this.refreshIntervalTimer = setInterval(function () {
        datatable.draw('page');
      }, this.refreshInterval * 1000);
    }
  }

  exportFiles(event, format) {

    if(['docArray', 'dataArray'].includes(this.dataSource)){
      // const data = this.table.rows().data();
      let data = this.componentDefinition.dataSourceName ? this.contextParams.document[this.componentDefinition.dataSourceName] : [];
      if(typeof data === 'string'){
        data = JSON.parse(data);
      }

      const _format = this.componentDefinition.exportSettings;
      const fontSize = _format?.fontSize ?? 10;

      const defaultFormat = {
        fileName: (_format?.fileName ?? 'export') + '.' + format,
        size: _format?.size ?? 'A4',
        layout: _format?.layout ?? 'landscape',
        fontSize: fontSize,
        headerFontSize: _format?.headerFontSize ?? fontSize,
        margin: _format?.margin && _format?.margin <= 100 ? _format?.margin : 25,
        columnSpacing: _format?.columnSpacing ?? 5,
        rowSpacing: _format?.rowSpacing ?? 5,
      };

      if(this.dataSource === 'dataArray'){
        data = data.map(row => {
          return row.reduce((obj, value, index) => {
            obj[`index-${index}`] = value;
            return obj;
          }, {});
        });
      }


      if( format.toLowerCase() === 'pdf'){
        this.dtExport.exportPdf(data, this.sclExportService.headers, defaultFormat, this.contextParams);
      }else{

        this.dtExport.exportCsv(data, this.sclExportService.headers, defaultFormat, this.contextParams);
      }
      return;
    }

    this.sclExportService.format = format.toLowerCase();

    event.target.classList.add('loader');
    event.target.classList.add('disabled');

    const handlebarHelpers = sclHandlebars.defaultHelpers().concat(this.componentDefinition.handlebarsHelpers).filter( (el) => {
      return el != null && el !== undefined;
    });

    // Remove the max_export result warning notification 17603: sc-datatables - csv export of 10k records does not complete
    if (this.exportQuery?.size > MAX_EXPORT_RESULT) {
      this.exportQuery.size = MAX_EXPORT_RESULT;
    }


    let fileName = '';
    if (typeof this.document?.systemHeader?.summaryName === 'string'
		 && this.document.systemHeader.summaryName.trim().length > 0) {
		  fileName = this.document.systemHeader.summaryName.trim();
		} else if (typeof this.document?.name === 'string'
		 && this.document.name.trim().length > 0) {
		  fileName = this.document.name.trim();
		} else if (typeof this.template?.systemHeader?.summaryName === 'string'
		 && this.template.systemHeader.summaryName.trim().length > 0) {
		  fileName = this.template.systemHeader.summaryName.trim();
		} else if (typeof this.template?.name === 'string'
		 && this.template.name.trim().length > 0) {
		  fileName = this.template.name.trim();
		} else if (typeof this.fieldName === 'string'
		 && this.fieldName.trim().length > 0) {
		  fileName = this.fieldName.trim();
		}

    this.sclExportService.export(this.exportQuery, fileName, this.componentDefinition.exportSettings,
      handlebarHelpers, this.contextParams)
      .subscribe(x => {
        format = format.toLowerCase();
        const newBlob = new Blob([x], {type: 'application/' + format});

        const data = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = data;
        link.download = fileName + '.' + format;
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

        setTimeout(() => {
          window.URL.revokeObjectURL(data);
          link.remove();
          event.target.classList.remove('loader');
          event.target.classList.remove('disabled');
        }, 100);
      });
  }

  valueChanged(value) {
    // 19987: START: Removed the initComplete condition
    //  avoid dirty document on init
    // if (this.initComplete) {
    //   this.changedDocumentService.valueChanged(this, value, this.registeredControlName);
    // }
    // 19987: END

    this.changedDocumentService.valueChanged(this, value, this.registeredControlName);

    this.detectChanges();
  }

  initPagination(rowsPerPage) {

    const totalHits = this.pagination.total_items;
    this.pagination.rows_per_page = rowsPerPage;
    this.pagination.last_page = Math.ceil(totalHits / this.pagination.rows_per_page);
    this.pagination.more_items = totalHits - MAX_EXPORT_RESULT;

    if ( totalHits > MAX_EXPORT_RESULT && this.pagination.more_items > 0) {
      const pages = Math.ceil(MAX_EXPORT_RESULT / this.pagination.rows_per_page);
      this.pagination.last_page = pages;
      this.pagination.more_items = totalHits - (this.pagination.rows_per_page * pages);
    }


    // Starting Item is 5
    // if less 5, set to 3 items.. minus the start and end.
    const limitItem = (this.pagination.last_page < 5) ? this.pagination.last_page :  5;
    this.pagination.page_items = [];
    for( let i=0; i < limitItem; i++ ){
      this.pagination.page_items.push(i);
    }
    this.pagination.current_page = 1;
    this.pagination.extend = [];

    // this.detectChanges();
  }

  goTo(page) {

    if ( page === this.pagination.current_page){
      return;
    }

    if ( page > this.pagination.last_page ) {
      page = this.pagination.last_page;
    }

    this.pagination.current_page = page;


    this.table.page(page-1).draw('page');
  }

  goToCallback( page ){
    // this.pagination.current_page = page;
    const maxPage = this.pagination.last_page;
    if (page < 5) {
      const limitItem = (this.pagination.last_page < 5) ? this.pagination.last_page : 5;
      this.pagination.page_items = [];
      // if less 5, set to 3 items.. minus the start and end.
      if ( maxPage <= 5){
        for( let i=1; i <= maxPage - 2; i++ ){
          this.pagination.page_items.push(i+1);
        }
      }else{
        for( let i=2; i <= 5; i++ ){
          this.pagination.page_items.push(i);
        }
      }
    } else if (page > maxPage-4) {
      this.pagination.page_items = [];
      if ( maxPage <= 5){
        for( let i=2; i <= maxPage - 2; i++ ){
          this.pagination.page_items.push(i);
        }
      }else{
        for (let i = maxPage-5; i < maxPage-1; i++) {
          this.pagination.page_items.push(i+1);
        }
      }
    } else {
      this.pagination.page_items = [
        page - 1,
        page,
        page + 1];
    }

    this.detectChanges();
  }

  goDeep() {
    if ( this.pagination.more_items <= 0 ){
      return;
    }
    this.pagination.isDeep = true;

    this.pagination.extend.push({
      index: this.pagination.last_page,
      search_after: this.dtSearch.prevSortScore
    });
    this.pagination.current_page = this.pagination.last_page+1;

    this.table.page(this.pagination.last_page+1).draw('page');

  }

  goDeepCallback(page) {
    this.pagination.last_page = page;
    this.pagination.current_page = this.pagination.last_page;
    this.pagination.more_items -= this.pagination.rows_per_page;
    const maxPage = this.pagination.last_page;
    this.pagination.page_items = [];
    if ( maxPage <= 5){
      for( let i=1; i <= maxPage - 2; i++ ){
        this.pagination.page_items.push(i+1);
      }
    }else{
      for (let i = maxPage-5; i < maxPage-1; i++) {
        this.pagination.page_items.push(i+1);
      }
    }

    this.pagination.isDeep = false;
    this.detectChanges();
  }

  protected onDocumentCreated(documentInfo: any): void {
    super.onDocumentCreated(documentInfo);
    this.changeTemplateToogle = false;
    this.selectedChildDocId = null;
    this.showChildDocTitle = false;
    this.detectChanges();
  }

  isNumeric(str) {
    if (typeof str !== 'string') {
      return false;
    }
    return !isNaN(Number(str)) &&
           !isNaN(parseFloat(str));
  }

  ngOnDestroy() {
    if ( this.resizeObserver ) {
      this.resizeObserver.unobserve(this.dtWrapper.nativeElement);
    }
    super.ngOnDestroy();
    this.initCompleted = false;
  }
}
